<template>
  <div>
    {{ textField }}
  </div>
</template>

<script>
import moment from 'moment';

const varsList = [
  {
    key: '@nombre_completo',
    value: 'name',
  },
  {
    key: '@folio',
    value: 'folio',
  },
  {
    key: '@nombre',
    value: 'first_name',
  },
  {
    key: '@apellido',
    value: 'last_name',
  },
  {
    key: '@monto',
    value: 'amount',
  },
  {
    key: '@moneda',
    value: 'currency',
  },
  {
    key: '@referencia',
    value: 'reference',
  },
  {
    key: '@producto',
    value: 'account_type',
  },
  {
    key: '@tramo_de_mora',
    value: 'tranche',
  },
  {
    key: '@dia_de_vencimiento',
    value: 'due_day',
  },
  {
    key: '@cartera',
    value: 'portfolio_type',
  },
  {
    key: '@agencia',
    value: 'agency',
  },
  {
    key: '@genero',
    value: 'gender',
  },
  {
    key: '@estado',
    value: 'state',
  },
  {
    key: '@grupos_de_edad',
    value: 'age_group',
  },
  {
    key: '@agente',
    value: 'agent',
  },
  {
    key: '@numero',
    value: 'to',
  },
  {
    key: '@fecha_vencimiento',
    value: 'due_date',
  },
  {
    key: '@mañana',
    value: 'tomorrow',
  }
];

export default {
  props: {
    notificationSchedule: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      varsList,
    };
  },
  computed: {
    textField() {
      if (Object.keys(this.notificationSchedule).length) {
        const field = JSON.parse(this.notificationSchedule.text);
        field.vars = JSON.parse(field.vars);

        let text = field.text;
        this.varsList.forEach((item) => {
          if (text.indexOf(item.key) >= 0) {
            let value = field.vars[item.value] || '';
            if (['@fecha_vencimiento'].includes(item.key)) {
              value = moment(value).format('DD-MM-YYYY');
            }
            text = text.replace(item.key, value);
          }
        });
        return text;
      }
      return '';
    },
  },
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/global/AudioText.vue